import type { RouteConfig } from 'vue-router'

import * as namesConfiguracion from './nombres/configuracion'
import * as namesInformes from './nombres/informes'
import * as namesTransacciones from './nombres/transacciones'
import { buildBreadcrumb } from '@/@core/utils/router'
import permisosCxP, { RESOURCE_CXP } from '@/auth/permissions/modules/cxp'

const { configuracion, transacciones, informes } = permisosCxP

export default [
    /**
     * RUTAS DE CONFIGURACIÓN
     */
    {
        path: '/cuentas-x-pagar/configuracion/niveles-aprobacion-anticipos',
        name: namesConfiguracion.ROUTE_NIVEL_APROBACION_ANTICIPOS,
        component: () => import('@/views/pages/cuentasxpagar/mantenimiento/anticipos/PermisosNivelAprobacion.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.permisos_niveles_aprobacion',
            resource: RESOURCE_CXP,
            action: configuracion.nivelAprobacionAnticipos,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.configuracion',
                'cuentas_x_pagar.subopciones.permisos_niveles_aprobacion'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/configuracion/fecha-limite-regdoc',
        name: namesConfiguracion.ROUTE_FECHA_LIMITE_REGDOC,
        component: () => import('@/views/pages/cuentasxpagar/mantenimiento/documentos/EditFechaLimiteRegDoc.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.fecha_limite_regdoc',
            resource: RESOURCE_CXP,
            action: configuracion.fechaLimiteRegdoc,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.configuracion',
                'cuentas_x_pagar.subopciones.fecha_limite_regdoc'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/configuracion/asignacion-tareas',
        name: namesConfiguracion.ROUTE_ASIGNACION_TAREAS,
        component: () => import('@/views/pages/cuentasxpagar/mantenimiento/ConfiguracionAsignacionTareas.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.configuracion_asignacion_tareas',
            resource: RESOURCE_CXP,
            action: configuracion.asignacionTareas,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.configuracion',
                'cuentas_x_pagar.subopciones.configuracion_asignacion_tareas'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/configuracion/correo-alertas-pendientes',
        name: namesConfiguracion.ROUTE_CORREO_ALERTAS_PENDIENTE,
        component: () => import('@/views/pages/cuentasxpagar/configuracion/EmailAlertasRetencion.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.correo_alertas_pendientes',
            resource: RESOURCE_CXP,
            action: configuracion.correoAlertasPendientes,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.configuracion',
                'cuentas_x_pagar.subopciones.correo_alertas_pendientes'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/configuracion/usuarios-notificacion',
        name: namesConfiguracion.ROUTE_USUARIOS_NOTIFICACION,
        component: () => import('@/views/pages/cuentasxpagar/configuracion/ConfiguracionAlertas.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.configuracion_alertas',
            resource: RESOURCE_CXP,
            action: configuracion.usuariosNotificacion,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.configuracion',
                'cuentas_x_pagar.subopciones.configuracion_alertas'
            ),
        },
    },

    /**
     * RUTAS DE TRANSACCIONES
     */
    {
        path: '/cuentas-x-pagar/transacciones/bandeja-reembolso-interno',
        name: namesTransacciones.ROUTE_BANDEJA_REEMBOLSO_INTERNO,
        component: () =>
            import('@/views/pages/cuentasxpagar/transacciones/reembolso-interno/BandejaReembolsoInterno.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.bandeja_reembolso_interno',
            resource: RESOURCE_CXP,
            action: transacciones.reembolsos.reembolsoInterno,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.bandeja_reembolso_interno'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/reembolso-interno/:num_transaccion?',
        name: namesTransacciones.ROUTE_REEMBOLSO_INTERNO,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/reembolso-interno/ReembolsoInterno.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.reembolso_interno',
            resource: RESOURCE_CXP,
            action: transacciones.reembolsos.reembolsoInterno,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.reembolso_interno'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/aprobacion-reembolso-interno',
        name: namesTransacciones.ROUTE_APROBACION_REEMBOLSO_INTERNO,
        component: () =>
            import('@/views/pages/cuentasxpagar/transacciones/reembolso-interno/AprobacionReembolsoInterno.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.aprobacion_reembolso_interno',
            resource: RESOURCE_CXP,
            action: transacciones.reembolsos.aprobacionReembolsoInterno,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.aprobacion_reembolso_interno'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/bandeja-orden-pago',
        name: namesTransacciones.ROUTE_BANDEJA_ORDEN_PAGO,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/BandejaOrdenPago.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.bandeja_orden_pago',
            resource: RESOURCE_CXP,
            action: transacciones.ordenesPago.bandejaOrdenPago,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.bandeja_orden_pago'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/orden-pago-sin-flujo/:num_orden?',
        name: namesTransacciones.ROUTE_ORDEN_PAGO_SIN_FLUJO,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/OrdenPagoSinFlujo.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.orden_pago',
            resource: RESOURCE_CXP,
            action: transacciones.ordenesPago.ordenPagoSinFlujo,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.orden_pago'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/asignacion-ordenes-entrega',
        name: namesTransacciones.ROUTE_ASIGNACION_ORDEN_ENTREGA,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/AsignacionOrdenEntrega.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.asignacion_oe',
            resource: RESOURCE_CXP,
            action: transacciones.registroDocumentos.asignacionOrdenEntrega,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.asignacion_oe'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/bandeja-registro-documento',
        name: namesTransacciones.ROUTE_BANDEJA_REGISTRO_DOCUMENTO,
        component: () =>
            import('@/views/pages/cuentasxpagar/transacciones/registro-documento/BandejaRegistroDocumento.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.bandeja_registro_documento',
            resource: RESOURCE_CXP,
            action: transacciones.registroDocumentos.bandejaRegistroDocumento,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.bandeja_registro_documento'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/asignacion-tareas',
        name: namesTransacciones.ROUTE_ASIGNACION_TAREAS,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/AsignacionTareas.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.asignacion_tareas',
            resource: RESOURCE_CXP,
            action: transacciones.registroDocumentos.asignacionTareas,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.asignacion_tareas'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/registro-documento/:num_transaccion?',
        name: namesTransacciones.ROUTE_REGISTRO_DOCUMENTO,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/registro-documento/RegistroDocumento.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.registro_documento',
            resource: RESOURCE_CXP,
            action: transacciones.registroDocumentos.registroDocumento,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.registro_documento'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/aprobacion-registro-documento',
        name: namesTransacciones.ROUTE_APROBACION_REGISTRO_DOCUMENTO,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/aprobacion-registro-documento/Index.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.aprobacion_registro_documento',
            resource: RESOURCE_CXP,
            action: transacciones.registroDocumentos.aprobacionRegistroDocumento,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.aprobacion_registro_documento'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/aprobacion-cruce-regdoc',
        name: namesTransacciones.ROUTE_APROBACION_CRUCE_REGDOC,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/cruce-registro-documento/Index.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.aprobacion_cruce_regdoc',
            resource: RESOURCE_CXP,
            action: transacciones.registroDocumentos.aprobacionCruceRegdoc,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.aprobacion_cruce_regdoc'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/bandeja-abonos',
        name: namesTransacciones.ROUTE_BANDEJA_ABONOS,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/BandejaAbonos.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.bandeja_abonos',
            resource: RESOURCE_CXP,
            action: transacciones.abonos.bandejaAbonos,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.bandeja_abonos'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/abono/:num_transaccion?',
        name: namesTransacciones.ROUTE_CREAR_ABONO,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/CrearAbono.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.abonos',
            resource: RESOURCE_CXP,
            action: transacciones.abonos.crearAbono,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.abonos'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/anticipos/bandeja-anticipos',
        name: namesTransacciones.ROUTE_BANDEJA_ANTICIPOS,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/anticipos/BandejaAnticipos.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.bandeja_anticipos',
            resource: RESOURCE_CXP,
            action: transacciones.anticipos.bandejaAnticipos,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.anticipos',
                'cuentas_x_pagar.subopciones.bandeja_anticipos'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/anticipo/:num_transaccion?',
        name: namesTransacciones.ROUTE_CREAR_ANTICIPO,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/anticipos/CrearAnticipo.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.crear_anticipo',
            resource: RESOURCE_CXP,
            action: transacciones.anticipos.crearAnticipo,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.anticipos',
                'cuentas_x_pagar.subopciones.crear_anticipo'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/anticipos/aprobacion-anticipos',
        name: namesTransacciones.ROUTE_APROBACION_ANTICIPOS,
        component: () =>
            import(
                '@/views/pages/cuentasxpagar/transacciones/anticipos/anticipos-pendientes-aprobar/AnticiposPendientesAprobar.vue'
            ),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.aprobar_anticipos',
            resource: RESOURCE_CXP,
            action: transacciones.anticipos.aprobacionAnticipos,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.anticipos',
                'cuentas_x_pagar.subopciones.aprobar_anticipos'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/nota-credito/:num_transaccion?',
        name: namesTransacciones.ROUTE_NOTA_CREDITO,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/NotaCredito.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.nota_credito',
            resource: RESOURCE_CXP,
            action: transacciones.notasCredito.notaCredito,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.nota_credito'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/nota-debito/:num_transaccion?',
        name: namesTransacciones.ROUTE_NOTA_DEBITO,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/NotaDebito.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.nota_debito',
            resource: RESOURCE_CXP,
            action: transacciones.notaDebito,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.nota_debito'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/liquidacion-embarques/:num_transaccion?',
        name: namesTransacciones.ROUTE_LIQUIDACION_EMBARQUES,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/LiquidacionEmbarques.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.liquidacion_embarques',
            resource: RESOURCE_CXP,
            action: transacciones.liquidacionEmbarques,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.liquidacion_embarques'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/bandeja-nota-credito',
        name: namesTransacciones.ROUTE_BANDEJA_NOTA_CREDITO,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/BandejaNotaCredito.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.bandeja_nota_credito',
            resource: RESOURCE_CXP,
            action: transacciones.notasCredito.bandejaNotaCredito,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.bandeja_nota_credito'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/registro-gastos-importacion',
        name: namesTransacciones.ROUTE_BANDEJA_GASTOS_IMPORTACIONES_POR_REGISTRAR,
        component: () => import('@/views/pages/cuentasxpagar/transacciones/GastosImportacionPorRegistrar.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.bandeja_gastos_importacion',
            resource: RESOURCE_CXP,
            action: transacciones.registroDocumentos.importacionesPendientes,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.bandeja_gastos_importacion'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/liquidaciones/liquidaciones-compra/gestion',
        name: namesTransacciones.ROUTE_BANDEJA_LIQUIDACION_COMPRA_SERVICIO,
        component: () => import('@pages/cuentasxpagar/transacciones/liquidacion-compra/gestion/Index.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.bandeja_liquidacion_compra_servicios',
            resource: RESOURCE_CXP,
            action: transacciones.liquidacionCompraServicio,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.bandeja_liquidacion_compra_servicios'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/transacciones/liquidaciones/liquidaciones-compra/:numDocumento?',
        name: namesTransacciones.ROUTE_LIQUIDACION_COMPRA_SERVICIO,
        component: () => import('@pages/cuentasxpagar/transacciones/liquidacion-compra/Index.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.liquidacion_compra_servicios',
            resource: RESOURCE_CXP,
            action: transacciones.liquidacionCompraServicio,
            breadcrumb: buildBreadcrumb(
                'a:tributacion.menu_title',
                'a:global.menu.transacciones',
                'cuentas_x_pagar.subopciones.liquidacion_compra_servicios'
            ),
        },
    },

    /**
     * RUTAS DE INFORMES
     */
    {
        path: '/cuentas-x-pagar/informes/saldos-anticipos',
        name: namesInformes.ROUTE_INFORME_SALDOS_ANTICIPO,
        component: () => import('@/views/pages/cuentasxpagar/informes/SaldosAnticipos.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.saldo_anticipos',
            resource: RESOURCE_CXP,
            action: informes.saldoAnticipos,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.informes',
                'cuentas_x_pagar.subopciones.saldo_anticipos'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/informes/proveedores-corte',
        name: namesInformes.ROUTE_INFORME_PROVEEDORES_CORTE,
        component: () => import('@/views/pages/cuentasxpagar/informes/ObligacionesXpagar.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.proveedores_corte',
            resource: RESOURCE_CXP,
            action: informes.proveedoresCorte,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.informes',
                'cuentas_x_pagar.subopciones.proveedores_corte'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/informes/obligaciones-vencer-vencidas',
        name: namesInformes.ROUTE_INFORME_OBLIGACIONES_VENCER_VENCIDAS,
        component: () => import('@/views/pages/cuentasxpagar/informes/ObligacionesXVencerVencidas.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.obligaciones_vencer_vencida',
            resource: RESOURCE_CXP,
            action: informes.obligacionesVencerVencidas,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.informes',
                'cuentas_x_pagar.subopciones.obligaciones_vencer_vencida'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/informes/cartera-30-60-90',
        name: namesInformes.ROUTE_INFORME_CARTERA_30_60_90,
        component: () => import('@/views/pages/cuentasxpagar/informes/Cartera306090.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.cartera306090',
            resource: RESOURCE_CXP,
            action: informes.cartera306090,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.informes',
                'cuentas_x_pagar.subopciones.cartera306090'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/informes/estado-cuenta',
        name: namesInformes.ROUTE_INFORME_ESTADO_CUENTA,
        component: () => import('@/views/pages/cuentasxpagar/informes/EstadoCuenta.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.estado_cuenta',
            resource: RESOURCE_CXP,
            action: informes.estadoCuenta,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.informes',
                'cuentas_x_pagar.subopciones.estado_cuenta'
            ),
        },
    },
    {
        path: '/cuentas-x-pagar/informes/flujo-pago-proveedor',
        name: namesInformes.ROUTE_INFORME_FLUJO_PAGO_PROVEEDOR,
        component: () => import('@/views/pages/cuentasxpagar/informes/FlujoPagoXProveedor.vue'),
        meta: {
            title: 'i18n:cuentas_x_pagar.subopciones.flujo_pago_proveedor',
            resource: RESOURCE_CXP,
            action: informes.flujoPagoProveedor,
            breadcrumb: buildBreadcrumb(
                'a:cuentas_x_pagar.menu_title',
                'a:global.menu.informes',
                'cuentas_x_pagar.subopciones.flujo_pago_proveedor'
            ),
        },
    },
] as RouteConfig[]
